import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const CategoryFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const location = useLocation();
  const path = location.pathname.toLowerCase();

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // ✅ SUB TITLE
  const getSubTitle = () => {
    const parts = path.split("/").filter(Boolean);
    if (parts.length > 1) {
      return parts[parts.length - 1]
        .replace(/-/g, " ")
        .replace(/\b\w/g, c => c.toUpperCase());
    }
    return "";
  };

  const subTitle = getSubTitle();

  // ✅ MAIN TITLE
  const getMainTitle = () => {
    if (path.includes("proctology")) return "Proctology";
    if (path.includes("laparoscopy")) return "Laparoscopy";
    if (path.includes("urology")) return "Urology";
    if (path.includes("gynecology")) return "Gynecology";
    if (path.includes("aesthetic")) return "Aesthetics";
    if (path.includes("ent")) return "ENT";
    if (path.includes("fertility")) return "Fertility";
    if (path.includes("ortho")) return "Orthopedics";
    if (path.includes("weight")) return "Weight Loss";
    return "Treatment";
  };

  const mainTitle = getMainTitle();

  // ✅ MAIN FAQs
  const mainCategoryFAQs = {
    Proctology: ["What are piles?", "Is treatment painful?", "Laser safe?", "Recovery time?", "When to consult doctor?"],
    Laparoscopy: ["What is laparoscopy?", "Safe?", "Pain?", "Recovery?", "Better than open surgery?"],
    Urology: ["Common issues?", "Kidney stones treatment?", "Pain?", "Recovery?", "Need surgery?"],
    Gynecology: ["PCOS treatment?", "Safe?", "Consult when?", "Recovery?", "Options?"],
    Aesthetics: ["Safe?", "Recovery?", "Permanent?", "Pain?", "Cost?"],
    ENT: ["ENT issues?", "Surgery needed?", "Pain?", "Recovery?", "Safe?"],
    Fertility: ["When consult?", "IVF success?", "Safe?", "Cost?", "Time?"],
    Orthopedics: ["Joint pain causes?", "Surgery?", "Recovery?", "Physio?", "Pain control?"],
    "Weight Loss": ["What is bariatric?", "Safe?", "Eligible?", "Recovery?", "Results?"]
  };

  // ✅ FULL SUB FAQ DATA (ALL FROM SCREENSHOTS)
  const faqData = {

    // PROCTOLOGY
    piles: ["What are piles?", "Symptoms?", "Treatment?", "Laser safe?", "Recovery?"],
    fissure: ["What is fissure?", "Pain?", "Treatment?", "Healing?", "Prevention?"],
    fistula: ["What is fistula?", "Symptoms?", "Treatment?", "Surgery?", "Recovery?"],

    // LAPAROSCOPY
    femoral: ["Femoral hernia?", "Symptoms?", "Danger?", "Treatment?", "Recovery?"],
    incisional: ["Incisional hernia?", "Causes?", "Symptoms?", "Treatment?", "Recovery?"],
    hiatal: ["Hiatal hernia?", "Symptoms?", "Treatment?", "Surgery?", "Recovery?"],
    umbilical: ["Umbilical hernia?", "Symptoms?", "Treatment?", "Risk?", "Recovery?"],
    inguinal: ["Inguinal hernia?", "Symptoms?", "Treatment?", "Surgery?", "Recovery?"],
    appendicitis: ["Appendicitis?", "Symptoms?", "Emergency?", "Treatment?", "Recovery?"],
    hysterectomy: ["Hysterectomy?", "Why?", "Recovery?", "Risks?", "Safe?"],

    // UROLOGY
    circumcision: ["Circumcision?", "Safe?", "Recovery?", "Pain?", "Benefits?"],
    stapler: ["Stapler circumcision?", "Better?", "Recovery?", "Pain?", "Cost?"],
    laser: ["Laser circumcision?", "Benefits?", "Pain?", "Recovery?", "Safe?"],
    phimosis: ["Phimosis?", "Symptoms?", "Treatment?", "Surgery?", "Recovery?"],
    balanoposthitis: ["Balanoposthitis?", "Symptoms?", "Causes?", "Treatment?", "Prevention?"],
    pcnl: ["PCNL?", "Safe?", "Recovery?", "Pain?", "Success?"],
    rirs: ["RIRS?", "Benefits?", "Recovery?", "Pain?", "Safe?"],
    ursl: ["URSL?", "Procedure?", "Pain?", "Recovery?", "Success?"],
    hydrocele: ["Hydrocele?", "Symptoms?", "Treatment?", "Surgery?", "Recovery?"],
    prostate: ["Prostate issue?", "Symptoms?", "Treatment?", "Surgery?", "Safe?"],
    frenuloplasty: ["Frenuloplasty?", "Why?", "Pain?", "Recovery?", "Safe?"],
    kidney: ["Kidney stones?", "Symptoms?", "Treatment?", "Prevention?", "Pain?"],
    foreskin: ["Foreskin infection?", "Symptoms?", "Treatment?", "Prevention?", "Serious?"],

    // GYNECOLOGY
    mtp: ["MTP?", "Safe?", "Pain?", "Recovery?", "Legal?"],
    pcod: ["PCOD?", "Symptoms?", "Treatment?", "Diet?", "Serious?"],
    pcos: ["PCOS?", "Symptoms?", "Treatment?", "Fertility?", "Management?"],

    // AESTHETICS
    gynecomastia: ["Gynecomastia?", "Treatment?", "Surgery?", "Recovery?", "Permanent?"],
    lipoma: ["Lipoma?", "Danger?", "Treatment?", "Surgery?", "Recovery?"],

    // ENT
    turbinate: ["Turbinate?", "Why?", "Procedure?", "Recovery?", "Safe?"],
    nasal: ["Nasal polyps?", "Symptoms?", "Treatment?", "Surgery?", "Recovery?"],
    vocal: ["Vocal polyps?", "Symptoms?", "Treatment?", "Voice?", "Recovery?"],
    ear: ["Ear surgery?", "Types?", "Pain?", "Recovery?", "Safe?"],
    throat: ["Throat surgery?", "When?", "Pain?", "Recovery?", "Risks?"],
    myringotomy: ["Myringotomy?", "Why?", "Procedure?", "Recovery?", "Safe?"],
    stapedectomy: ["Stapedectomy?", "Hearing?", "Procedure?", "Recovery?", "Safe?"],
    tonsillectomy: ["Tonsillectomy?", "Why?", "Pain?", "Recovery?", "Safe?"],
    thyroidectomy: ["Thyroidectomy?", "Why?", "Recovery?", "Risks?", "Safe?"],
    fess: ["FESS?", "Benefits?", "Recovery?", "Pain?", "Safe?"],
    mastoidectomy: ["Mastoidectomy?", "Why?", "Procedure?", "Recovery?", "Safe?"],
    septoplasty: ["Septoplasty?", "Why?", "Recovery?", "Pain?", "Safe?"],
    sinus: ["Sinus?", "Symptoms?", "Treatment?", "Surgery?", "Recovery?"],

    // FERTILITY
    iui: ["IUI?", "Success?", "Pain?", "Cost?", "Safe?"],
    ivf: ["IVF?", "Success?", "Cost?", "Pain?", "Safe?"],
    male: ["Male infertility?", "Treatment?", "Tests?", "Improve?", "Doctor?"],
    female: ["Female infertility?", "Treatment?", "Tests?", "Options?", "Success?"],
    egg: ["Egg freezing?", "Why?", "Process?", "Safe?", "Cost?"],

    // ORTHOPEDICS
    knee: ["Knee replacement?", "Pain?", "Recovery?", "Success?", "Physio?"],
    shoulder: ["Shoulder arthroscopy?", "Procedure?", "Pain?", "Recovery?", "Safe?"],
    arthroscopy: ["Arthroscopy?", "Benefits?", "Recovery?", "Pain?", "Safe?"],
    rotator: ["Rotator cuff?", "Symptoms?", "Treatment?", "Recovery?", "Safe?"],
    meniscus: ["Meniscus tear?", "Symptoms?", "Treatment?", "Recovery?", "Surgery?"],
    acl: ["ACL tear?", "Symptoms?", "Treatment?", "Recovery?", "Sports?"],
    carpal: ["Carpal tunnel?", "Symptoms?", "Treatment?", "Surgery?", "Recovery?"],

    // WEIGHT LOSS
    bariatric: ["Bariatric?", "Safe?", "Results?", "Recovery?", "Permanent?"]
  };

  // ✅ MATCH
  let matchedKey = Object.keys(faqData).find(key => path.includes(key));

  let questions = [];
  let finalTitle = "";

  if (matchedKey) {
    questions = faqData[matchedKey];
    finalTitle = subTitle
      ? `${mainTitle} - ${subTitle} FAQs`
      : `${mainTitle} FAQs`;
  } else if (mainCategoryFAQs[mainTitle]) {
    questions = mainCategoryFAQs[mainTitle];
    finalTitle = `${mainTitle} FAQs`;
  }

  if (questions.length === 0) return null;

  return (
    <section style={{ padding: "40px", background: "#f7f8fb" }}>
      <h2 style={{ textAlign: "center", marginBottom: "30px" }}>
        {finalTitle}
      </h2>

      <div style={{ maxWidth: "900px", margin: "auto" }}>
        {questions.map((q, i) => (
          <div key={i}>
            <div
              style={{
                background: "#e5e7eb",
                padding: "15px",
                borderRadius: "10px",
                marginBottom: "10px",
                display: "flex",
                justifyContent: "space-between",
                cursor: "pointer"
              }}
              onClick={() => toggleFAQ(i)}
            >
              <span>{q}</span>
              <span>{activeIndex === i ? "−" : "+"}</span>
            </div>

            {activeIndex === i && (
              <div style={{
                background: "#f3f4f6",
                padding: "15px",
                borderRadius: "10px",
                marginBottom: "15px"
              }}>
                This depends on the condition. Please consult a doctor.
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default CategoryFAQ;